import { Injectable } from '@angular/core';
import { BaseGridService } from 'ngx-mt-ui-lib/services/base-grid';
import { Filters, IGridSorting, ISelectItem } from 'ngx-mt-ui-lib/interfaces';
import { GRID_ID } from '@app/app.enums';
import { ECriteria } from 'ngx-mt-ui-lib/enums';
import { IInitEventSecurityGridItem } from 'ngx-mt-ui-lib/api-client';

export type TSecurityEventsGridFilters = {
  initEventStateCode: Filters.TFilterModel<
    'initEventStateCode',
    string,
    string
  >;
  critLevelId: Filters.TFilterModel<
    'critLevelId',
    number,
    ISelectItem<unknown, number>[]
  >;
};

@Injectable()
export class SecurityEventsGridService extends BaseGridService<
  IInitEventSecurityGridItem,
  TSecurityEventsGridFilters
> {
  public override readonly gridId = GRID_ID['EVENT.SECURITY'];

  protected override readonly defaultFilters: TSecurityEventsGridFilters = {
    initEventStateCode: {
      field: 'initEventStateCode',
      criteria: ECriteria.equals,
      value: null,
    },
    critLevelId: {
      field: 'critLevelId',
      value: null,
      criteria: ECriteria.in,
    },
  };

  protected override readonly defaultSorting: IGridSorting[] = [
    {
      field: 'createdAt',
      direction: 'desc',
      index: 0,
    },
  ];

  constructor() {
    super();
    this.init();
  }

  public getDefaultSorting() {
    return this.defaultSorting ?? [];
  }
}
